/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

// eslint-disable-next-line no-shadow
export enum FilterType {
    Hidden = 'Hidden',
    SingleSelect = 'SingleSelect',
    MultipleSelect = 'MultipleSelect',
    TextBox = 'TextBox',
    Alphabet = 'Alphabet',
    Sort = 'Sort',
}
